import {Component} from '@angular/core';
/**
 * \@title Menu with icons
 */
export class MenuIconsExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'menu-icons-example',
  templateUrl: 'menu-icons-example.html',
  styleUrls: ['menu-icons-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MenuIconsExample_tsickle_Closure_declarations() {
/** @type {?} */
MenuIconsExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MenuIconsExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
